export default "__VITE_ASSET__8d2e7b0e__"